<template>
  <div class="play-card-btn relative mx-auto w-full">
    <img
      class="mx-auto"
      :src="image ? image.image : ''"
      :alt="image ? image.description : ''" />
    <div class="play-btn">
      <PlayButton></PlayButton>
    </div>
  </div>
</template>

<script>
import PlayButton from "../../Svgs/Icons/PlayButton.vue";

export default {
  components: {
    PlayButton,
  },

  props: {
    image: {
      type: [Object, null],
      required: true,
    },
  },
};
</script>
